<mat-dialog-actions class="bar-dialog">
    <span class="bar-text-dialog">Selecciona tu Sucursal preferida</span>
    <button class="bar-exit-dialog" mat-icon-button mat-dialog-close align="end"><mat-icon>close</mat-icon></button>
</mat-dialog-actions>
<mat-dialog-content class="content-vertical-detail">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" style="margin: 0px; padding-left: 0px; padding-right: 0px;" *ngIf="sucursales.length > 0">
        <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapClick)="onMapClickEvent($event)">
            <agm-marker *ngFor="let sucursal of sucursales;" [latitude]="sucursal.latitud" [longitude]="sucursal.longitud" [markerClickable]="true" (markerClick)="selectedBranch(sucursal, infoWindow)">
                <agm-info-window #infoWindow>
                    <p style="font-weight: 600; font-size: 1rem;">Sucursal: {{sucursal.nombre}}</p>
                    <button class="gray-button" mat-raised-button style="width: 100%;" (click)="selectBranch();" *ngIf="sucursal.idSucursal != sucursalSelected.idSucursal">Seleccionar</button>
                    <button class="gray-button" mat-raised-button style="width: 100%;" *ngIf="sucursal.idSucursal == sucursalSelected.idSucursal" [disabled]="true">Seleccionada</button>
                </agm-info-window>
            </agm-marker>
        </agm-map>
    </div>
</mat-dialog-content>